import React from 'react';
import DesktopProfileBottom728x90Fs from './freestar/DesktopProfileBottom728x90';
const DesktopProfileBottom728x90 = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(DesktopProfileBottom728x90Fs, {
        safety: safety
    });
};
DesktopProfileBottom728x90.displayName = 'DesktopProfileBottom728x90';
export default DesktopProfileBottom728x90;
